import { TTheme } from '@/core/theme'
import Typography from '@/ui/components/typography'
import { keyframes, styled } from '@mui/system'

const fadeIn = keyframes`
    from { opacity: 0; }
    to { opacity: 1; }
`

const arcSweep = keyframes`
    0% {
        stroke-dashoffset: 360;
        transform: rotate(0deg);
    }
    60% {
        stroke-dashoffset: 120;
    }
    100% {
        stroke-dashoffset: 360;
        transform: rotate(360deg);
    }
`

export const Screen = styled('div')<{ theme?: TTheme }>`
    position: fixed;
    inset: 0;
    z-index: 1000;
    background-color: ${({ theme }) => theme.colors.greys[50]};
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 24px;
    animation: ${fadeIn} 600ms cubic-bezier(0.39, 0.575, 0.565, 1) both;
`

export const EyebrowRow = styled('div')`
    display: inline-flex;
    align-items: center;
    gap: 8px;
`

export const EyebrowText = styled(Typography)<{ theme?: TTheme }>`
    && {
        letter-spacing: 0.2em;
        text-transform: uppercase;
        color: ${({ theme }) => theme.colors.primary[200]};
    }
`

export const Wordmark = styled(Typography)<{ theme?: TTheme }>`
    && {
        margin: 6px 0 48px;
        line-height: 1;
        letter-spacing: -0.02em;
        color: ${({ theme }) => theme.colors.greys[800]};
    }
`

export const IndicatorBox = styled('div')<{ size: number }>`
    position: relative;
    margin: 0 auto 48px;
    width: ${({ size }) => size}px;
    height: ${({ size }) => size}px;
`

export const ArcSvg = styled('svg')`
    position: absolute;
    inset: 0;
    transform-origin: 50% 50%;

    circle:last-of-type {
        animation: ${arcSweep} 2.4s cubic-bezier(0.45, 0.05, 0.25, 1) infinite;
        transform-origin: 50% 50%;
    }
`

export const LogoWrap = styled('div')`
    position: absolute;
    inset: 0;
    display: grid;
    place-items: center;
`
